import React, { type FC } from 'react';
import { range } from 'lodash-es';
import { BaseIcon } from '@is24at/react-ui-core/Icons';
import styles from './Stars.scss';

type Props = {
  id: string;
  amount: number;
};

export const Stars: FC<Props> = ({ id, amount }) => (
  <div className={styles.stars}>
    {range(amount).map((index) => (
      <div key={`${id}_${index}`} className={styles.stars__star}>
        <BaseIcon viewBox="0 0 48 48" size="100%">
          <path
            fill="#333"
            d="M24 5l-6 12H4l9.62 11.05L10 43l14-7.72L38 43l-3.61-14.94L44 17H30L24 5z"
          />
        </BaseIcon>
      </div>
    ))}
  </div>
);
